module.exports = __webpack_public_path__ + "img/HABLAR_GABY.74bbc93c.png";